import React from 'react';
import libbyMarkSrc from '../assets/libby-mark.png';

const VARIANT_CLASS = {
  light: 'libby-mark--multiply',
  dark: 'libby-mark--dark',
  neutral: 'libby-mark--neutral',
  none: '',
};

export default function LibbyMark({
  size = 40,
  variant = 'light',
  className = '',
  style,
  src = libbyMarkSrc,
  alt = 'Libby the Lion mark',
  ...rest
}) {
  const v = VARIANT_CLASS[variant] ?? VARIANT_CLASS.light;
  return (
    <img
      src={src}
      alt={alt}
      width={size}
      height={size}
      decoding="async"
      className={`libby-mark ${v} ${className}`.trim()}
      style={{ width: size, height: size, ...style }}
      {...rest}
    />
  );
}
